module.exports = __webpack_public_path__ + "img/NBU-01.91d991bf.png";